import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    bomRow: {
      background: "#fff !important",
      "& td": {
        borderTop: "1px dashed #ccc !important"
      }
    },
    rowFlex: {
      display: "flex",
      alignItems: "center",
      gap: 10
    },
    buttonPanel: {
      justifyContent: "center"
    },
    buttonAction: {
      height: 48,
      padding: "12px 40px",
      margin: "0 10px"
    },
    required: {
      color: theme.palette.error.main,
      marginLeft: 1,
      "& :after": {
        content: "*"
      }
    },
    dialogTitle: {
      textAlign: "left",
      padding: "20px 24px 10px"
    },
    btnExternal: {
      height: 32,
      margin: "-3px -0.8px",
      minWidth: 32,
      width: 36,
      padding: 6
    },
    CpTable: {
      margin: 0,
      "& > div:first-child": {
        margin: 0
      }
    },

    root: {
      "& .MuiTable-root": {
        "& .Mui-selected": {
          backgroundColor: "#ffffff",
          "&:hover": {
            backgroundColor: "#f1fafb"
          },
          "&:nth-child(even)": {
            backgroundColor: "#f1fafb",
            "&:hover": {
              backgroundColor: "#ffffff"
            }
          }
        }
      },
      "& .MuiPaper-root": {
        maxWidth: 1440,
        width: "100%",
        borderRadius: 12
      },
      "& .MuiDialogTitle-root": {
        paddingTop: 24
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "1.4rem",
        lineHeight: "22px",
        color: theme.palette.grey[900]
      },
      "& .MuiRadio-root svg": {
        width: 18,
        height: 18
      }
    },
    Pad: {
      overflow: "auto",
      padding: "10px 24px 10px 24px"
    },
    ListWrapper: {
      marginTop: "0",
      minWidth: "100%",
      background: theme.palette.common.white,
      border: "1px solid #009FB8",
      borderRadius: "4px"
    },
    MarginTop: {
      marginTop: "0px !important"
    },

    nameHead: {
      marginBottom: 5
    },
    itemText: {
      color: `${theme.palette.error.light} !important`
    },
    itemNoChild: {
      color: "#999999"
    },
    itemNoParent: {
      color: "#222222"
    },
    confirmDate: {
      color: "#FF2600"
    },
    flip: {
      transform: "rotate(180deg) scaleX(-1)"
    },
    cpUnitWeight: {
      paddingLeft: "4px"
    }
  }),
  {
    name: "CPResultModal"
  }
);

export default useStyles;
